import Vue from 'vue'

export default new Vue({
	data() {
	},
	created() {
	},
	methods: {
	}
})





